var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.023,
    height: 29.905,
    viewBox: "0 0 34.023 29.905",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_1_",
    "data-name": "calendar (1)",
    transform: "translate(0 -30.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11746",
    "data-name": "Path 11746",
    d: "M1,166.937h26.05a1,1,0,0,0,.639-.231c.25-.21,5.958-5.12,6.306-15.718H6.012c-.347,9.621-5.6,14.143-5.658,14.188A1,1,0,0,0,1,166.937Z",
    transform: "translate(0 -112.025)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11747",
    "data-name": "Path 11747",
    d: "M117.957,32.982h-4.984v-1a1,1,0,1,0-1.994,0v1h-5.051v-1a1,1,0,1,0-1.994,0v1H98.951v-1a1,1,0,1,0-1.994,0v1H91.973a.987.987,0,0,0-1,1v2.99h27.978v-2.99A.987.987,0,0,0,117.957,32.982Z",
    transform: "translate(-84.93)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11748",
    "data-name": "Path 11748",
    d: "M113.9,305.331a3,3,0,0,1-1.919.7h-21v2.99a1,1,0,0,0,1,1h25.984a1,1,0,0,0,1-1V297.843A19.757,19.757,0,0,1,113.9,305.331Z",
    transform: "translate(-84.931 -249.121)",
    fill: "#df9426"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.b14718251d69e44464ee7f07cc251432.svg";
export { ForwardRef as ReactComponent };